import { render, staticRenderFns } from "./CreateVisiteMedical.vue?vue&type=template&id=9871d328&scoped=true&"
import script from "./CreateVisiteMedical.vue?vue&type=script&lang=js&"
export * from "./CreateVisiteMedical.vue?vue&type=script&lang=js&"
import style0 from "./CreateVisiteMedical.vue?vue&type=style&index=0&id=9871d328&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9871d328",
  null
  
)

export default component.exports